module.exports = __webpack_public_path__ + "img/22.4fc60ac8.png";